export default {
      id: "icon-whatsapp-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-whatsapp",
      toString: function () {
        return this.url;
      }
    }